import { get } from 'lodash'
import identity from 'lodash/identity'
import { NestedKeys } from 'src/common/types/helpers'

// Typing improvement: Use Iteratee to allow path or function
export type Iteratee<In = unknown, Out = unknown> =
  | string
  | ((element: In) => Out)

export const extract = <In, Out>(
  item: In,
  iteratee: Iteratee<In, Out>
): Out => {
  if (typeof iteratee === 'string') {
    return get(item, iteratee) as Out
  }
  return iteratee(item)
}

export const mapBy = <T, Value extends (el: T) => any = (el: T) => T>(
  arr: T[],
  path: NestedKeys<T>,
  value?: Value
): Map<string, Value extends undefined ? T : ReturnType<Value>> => {
  const extractValue = value ?? identity

  return new Map(
    arr.map(el => {
      const key = extract(el, path) as string // Ensure TypeScript knows key is a string
      const normalizedKey = key.toLowerCase()
      return [normalizedKey, extractValue(el)] as [
        string,
        Value extends undefined ? T : ReturnType<Value>
      ]
    })
  )
}
